import {
  CLEAR_GROUPS,
  GROUPS_FETCHED,
  SET_GROUPS,
  SET_GROUP_MEMBERS,
  UPDATE_GROUP,
  DELETE_GROUP,
  UPDATE_LIST_CONFIG,
  GROUPS_LOADING,
} from '../../constants';

import { IReduxAction } from '../../interfaces';

export interface IGroupListConfig {
  search: string;
  filter: string;
  sort: string;
  pagination: {
    limit: number,
    lastItem: object | null,
  };
}

interface IGroupsState {
  list: object[];
  selected: object | null;
  listConfig: IGroupListConfig;
  fetched: boolean;
  moreGroups: boolean;
  loading: boolean;
}

const initState: IGroupsState = {
  list: [],
  selected: null,
  listConfig: {
    search: '',
    filter: 'all',
    sort: 'name-ascend',
    pagination: {
      limit: 15,
      lastItem: null,
    },
  },
  fetched: false,
  moreGroups: true,
  loading: false,
};

const setGroupStateMembers = (groupMembers: any, groups: any) => {
  const selectedGroup = groups.filter((group: any) => group.id === groupMembers.groupId);
  selectedGroup.forEach((group: any) => {
    group.members = groupMembers.members;
  });

  return [
    ...groups,
  ];
};

export function groupsReducer(state = initState, action: IReduxAction) {
  switch (action.type) {
    case GROUPS_FETCHED:
      return {
        ...state,
        fetched: action.payload,
      };

    case CLEAR_GROUPS:
      return {
        ...state,
        list: action.payload,
        fetched: false,
        moreGroups: true,
        listConfig: {
          ...state.listConfig,
          pagination: {
            ...state.listConfig.pagination,
            lastItem: null,
          },
        },
      };

    case UPDATE_GROUP:
      return {
        ...state,
        list: state.list
          .map((item: any) =>
            item.id === action.payload.id
              ? action.payload
              : item,
          ),
      };

    case DELETE_GROUP:
      return {
        ...state,
        list: state.list.filter((item: any) => item.id !== action.payload),
      };

    case SET_GROUPS:
      return {
        ...state,
        list: [
          ...state.list,
          ...action.payload,
        ],
        moreGroups: !(action.payload.length < state.listConfig.pagination.limit),
        loading: false,
      };

    case GROUPS_LOADING:
      return {
        ...state,
        loading: true,
      };

    case SET_GROUP_MEMBERS:
      return {
        ...state,
        list: setGroupStateMembers(action.payload, state.list),
      };

    case UPDATE_LIST_CONFIG:
      return {
        ...state,
        listConfig: action.payload,
      };

    default:
      return state;
  }
}
